import React from 'react';
import axios from 'axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  IconButton,
  TextField,
} from '@mui/material';
import { Close as CloseIcon, Business as BusinessIcon } from '@mui/icons-material';

const AdminCompaniesModal = ({ open, onClose, companies, onSelectCompany, isLoading }) => {
  const [loadingCompany, setLoadingCompany] = React.useState(null);
  const [searchTerm, setSearchTerm] = React.useState('');

  const selectedCompany = JSON.parse(localStorage.getItem('selectedCompany') || 'null');
  const currentCompanyId = selectedCompany?.id;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
          bgcolor: 'background.paper',
          color: 'text.primary',
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: '#6c63ff',
          color: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2.5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <BusinessIcon sx={{ fontSize: 28 }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Selecione uma Empresa
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            color: '#fff',
            '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' },
          }}
          aria-label="Fechar modal"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, bgcolor: 'background.paper' }}>
        <Box sx={{ p: 3, bgcolor: 'background.paper' }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Selecione a empresa que deseja acessar:
          </Typography>

          {/* ADICIONAR ESTE BLOCO */}
          <TextField
            fullWidth
            size="small"
            placeholder="Buscar empresa..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              mb: 2,
              bgcolor: 'background.paper',
              borderRadius: 1,
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: '#6c63ff',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#6c63ff',
                },
              },
            }}
          />

          <TableContainer
            component={Paper}
            elevation={0}
            sx={{
              border: (theme) => `1px solid ${theme.palette.divider}`,
              borderRadius: 2,
              overflow: 'hidden',
              bgcolor: 'background.paper',
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: (theme) => theme.palette.action.hover }}>
                  <TableCell
                    sx={{
                      fontWeight: 700,
                      color: 'text.primary',
                      fontSize: '0.875rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    Empresa
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={{
                      fontWeight: 700,
                      color: 'text.primary',
                      fontSize: '0.875rem',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      width: 150,
                    }}
                  >
                    Ação
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {companies && companies.length > 0 ? (
                  [...(companies || [])]
                    .sort((a, b) =>
                      (a.nome || a.name || '').localeCompare(
                        b.nome || b.name || '',
                        'pt',
                        { sensitivity: 'base' }
                      )
                    )
                    .filter((company) => { // ADICIONAR ESTE FILTRO
                      const nome = (company.nome || company.name || '').toLowerCase();
                      return nome.includes(searchTerm.toLowerCase());
                    })
                    .map((company, index) => (
                      <TableRow
                        key={company.id || index}
                        sx={{
                          '&:hover': {
                            bgcolor: company.id === currentCompanyId
                              ? (theme) => theme.palette.mode === 'dark' ? 'rgba(76, 175, 80, 0.18)' : '#e8f5e9'
                              : 'action.hover',
                          },
                          '&:last-child td': {
                            border: 0,
                          },
                          bgcolor: company.id === currentCompanyId
                            ? (theme) => theme.palette.mode === 'dark' ? 'rgba(76, 175, 80, 0.14)' : '#e8f5e9'
                            : 'transparent',
                        }}
                      >
                        <TableCell
                          sx={{
                            fontSize: '0.95rem',
                            color: 'text.primary',
                            py: 2,
                          }}
                        >
                          {company.nome || company.name || 'Nome não disponível'}
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            variant="contained"
                            size="small"
                            onClick={async () => {
                              setLoadingCompany(company);
                              try {
                                const token = localStorage.getItem('jwtToken');
                                const apiUrl = process.env.REACT_APP_API_BASE_URL;

                                const response = await axios.post(
                                  `${apiUrl}/login/integrador`,
                                  { idCliente: company.id },
                                  { headers: { Authorization: `Bearer ${token}` } }
                                );

                                // Salva o novo token
                                localStorage.setItem('jwtToken', response.data.token);
                                localStorage.setItem('selectedCompany', JSON.stringify(company));
                                window.dispatchEvent(new Event('empresaMudou'));

                                // Chama a função de seleção
                                onSelectCompany(company);
                              } catch (error) {
                                console.error('Erro ao selecionar empresa:', error);
                                alert('Erro ao selecionar empresa. Tente novamente.');
                              } finally {
                                setLoadingCompany(null);
                              }
                            }}
                            sx={{
                              bgcolor: company.id === currentCompanyId ? '#4caf50' : '#6c63ff',
                              color: '#fff',
                              borderRadius: '20px',
                              px: 3,
                              py: 0.8,
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              textTransform: 'none',
                              boxShadow: 'none',
                              '&:hover': {
                                bgcolor: company.id === currentCompanyId ? '#4caf50' : '#574fd8',
                                boxShadow: company.id === currentCompanyId ? 'none' : '0 4px 12px rgba(108, 99, 255, 0.3)',
                              },
                              '&.Mui-disabled': {
                                bgcolor: '#4caf50',
                                color: '#fff',
                                opacity: 0.8,
                              },
                            }}
                          >
                            {company.id === currentCompanyId ? 'Acessar' : 'Acessar'}
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                      <Typography variant="body2" color="text.secondary">
                        Nenhuma empresa disponível
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>

      {loadingCompany && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            backdropFilter: 'blur(4px)',
          }}
        >
          <Box
            sx={{
              width: 60,
              height: 60,
              border: '4px solid rgba(108, 99, 255, 0.3)',
              borderTop: '4px solid #6c63ff',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              mb: 3,
              '@keyframes spin': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
              },
            }}
          />
          <Typography variant="h6" sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>
            Entrando em {loadingCompany.nome || loadingCompany.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)' }}>
            Aguarde um momento...
          </Typography>
        </Box>
      )}
    </Dialog>
  );
};

export default AdminCompaniesModal;
